import React, { useRef } from "react";
import { WordCloud } from "@ant-design/charts";

const basic = {
	autoFit: true,
	wordField: "key",
	weightField: "value",
	color: "#122c6a",
	wordStyle: {
		fontFamily: "Verdana",
		fontSize: [20, 60],
	},
	interactions: [{ type: "element-active" }],
	state: {
		active: {
			style: {
				lineWidth: 3,
			},
		},
	},
};

export default function WordCloudChart(chartData = [], chartConfig = {}) {
	const ref = useRef();

	const config = {
		data: chartData,
		...basic,
	};

	return <WordCloud {...config} chartRef={ref} />;
}
